
// const baseURL =  "http://localhost:8000/" //local
const baseURL="https://salesbudget.gsk.com/api/"  //UAT

export {baseURL};
